import { ContractConceptRelationship } from '../../models/Entities/Contracts/ContractConceptRelationship';
import { CommonState } from '../common/state/commonState';

export interface ContractConceptRelationshipState extends CommonState<ContractConceptRelationship> {}

export const ContractConceptRelationshipUnloadState: any = {
  // loading all
  isLoadingAll: false,
  successLoadingAll: undefined,
  failOnLoadingAll: false,

  // loading one
  isLoadingOne: false,
  successLoadingOne: undefined,
  failOnLoadingOne: false,

  // adding
  isAddingNewOne: false,
  successAddingNewOne: undefined,
  failOnAddingNewOne: false,

  // updating
  isUpdatingOne: false,
  successUpdatingOne: undefined,
  failOnUpdatingOne: false,

  // deleting
  isDeletingOne: false,
  successDeletingOne: undefined,
  failOnDeletingOne: false,

  // data
  list: [],
  error: undefined,
};
